import {v4} from 'uuid';

export default class St {
    vuetify = null;
    router = null;
    api = null;

    deviceId = '';
    sessionId= '';
    referrer = '';

    constructor(vuetify, router, api) {
        this.vuetify = vuetify;
        this.router = router;
        this.api = api;
        this.deviceId = localStorage.getItem('st-device-id');
        if (!this.deviceId) {
            this.deviceId = v4();
            localStorage.setItem('st-device-id', this.deviceId);
        }
        this.sessionId = sessionStorage.getItem('st-session-id');
        if (!this.sessionId) {
            this.sessionId = v4();
            sessionStorage.setItem('st-session-id', this.sessionId);
        }
        this.referrer = document.referrer;
    }

    send(type, data) {
        const payload = {
            timestamp: Date.now(),
            deviceId: this.deviceId,
            sessionId: this.sessionId,
            deviceSize: this.vuetify.framework.breakpoint.name,
            path: this.router.currentRoute.fullPath,
            referrer: this.referrer,
            userId: this.api.getUserId(),
            eventType: type,
            eventData: data,
        }
        navigator.sendBeacon('/st', JSON.stringify(payload));
        this.referrer = '';
    }
}
